import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@xpeng/xdragon-ass-components/es/services/ajax';

export interface BookmapTopicDetailReq {
  /**
   * 手册编码
   */
  bookmapCode?: string;
  /**
   * 手册版本
   */
  bookmapVersion?: string;
  /**
   * 文章编码
   */
  topicCode?: string;
  /**
   * 文章版本
   */
  topicVersion?: string;
}

export interface CircuitInfoResp {
  /**
   * 释义列表
   */
  definitionList?: Definition[];
  /**
   * 电路参数列表
   */
  pcodeList?: string[];
  /**
   * 电路图SVG图文件ID
   */
  svgFileId?: string;
  /**
   * 文章编码
   */
  topicCode?: string;
  /**
   * 文章名称
   */
  topicName?: string;
}
export interface Definition {
  /**
   * 释义
   */
  definition?: string;
  /**
   * 编码
   */
  pcode: string;
  /**
   * 备注
   */
  remark?: string;
}

/**
 * @operationId circuitInfoUsingPOST
 * @tags 手册
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-tis-cn-boot/doc.html#/%E6%89%8B%E5%86%8C/%E6%89%8B%E5%86%8C/circuitInfoUsingPOST
 */
export function circuitInfoUsingPost(
  data: BookmapTopicDetailReq
): XDragonApiResponsePromise<CircuitInfoResp> {
  return ajax({
    url: '/api/tis/web/bookmap/topic/circuitInfo',
    method: 'post',
    data: data
  });
}
